module.exports = __webpack_public_path__ + "static/boardmember-0803646789232fad3741766cfa385417.jpg";